import store from "./index";
import eventBus from "@/utils/eventBus";
import toast from "@/utils/toast";
import { deepCopy, uuid } from "@/utils/utils";

function regenerateComponentTreeIds(comp) {
  const c = deepCopy(comp);
  const walk = (node) => {
    if (!node || typeof node !== "object") {
      return;
    }
    if (node.id && node.id !== "Back") {
      node.id = uuid();
    }
    if (Array.isArray(node.propValue)) {
      node.propValue.forEach(walk);
    }
  };
  walk(c);
  return c;
}

function bumpStyle(style, dx, dy) {
  if (!style) {
    return;
  }
  style.left = (Number(style.left) || 0) + dx;
  style.top = (Number(style.top) || 0) + dy;
}

export default {
  state: {
    copyData: null,
    isCut: false,
  },
  mutations: {
    copy(state, isBatch) {
      if (!isBatch && !state.curComponent) {
        toast("请选择组件");
        return;
      }

      restorePreCutData(state);
      copyData(state, isBatch);

      state.isCut = false;
    },

    paste(state, isMouse) {
      if (!state.copyData) {
        toast("请选择组件");
        return;
      }

      const raw = state.copyData.data;
      const keepIds = state.isCut;
      const cloneTree = (item) => (keepIds ? deepCopy(item) : regenerateComponentTreeIds(item));
      if (Array.isArray(raw)) {
        const { areaStyle } = state.copyData;
        let missTop = 10;
        let missLeft = 10;
        if (isMouse) {
          missTop = state.pasteCanvasTop - (areaStyle && areaStyle.top ? areaStyle.top : 0);
          missLeft = state.pasteCanvasLeft - (areaStyle && areaStyle.left ? areaStyle.left : 0);
        }
        const components = raw.map((item) => {
          const _c = cloneTree(item);
          bumpStyle(_c.style, missLeft, missTop);
          return _c;
        });
        store.commit("batchAddComponents", { components });
        if (!isMouse && !state.isCut) {
          raw.forEach((item) => bumpStyle(item.style, 10, 10));
          if (areaStyle) {
            bumpStyle(areaStyle, 10, 10);
          }
        }
      } else {
        const clone = cloneTree(raw);
        if (isMouse) {
          clone.style.top = state.pasteCanvasTop;
          clone.style.left = state.pasteCanvasLeft;
        } else {
          bumpStyle(clone.style, 10, 10);
        }
        store.commit("addComponent", { component: clone });
        if (!isMouse && !state.isCut) {
          bumpStyle(raw.style, 10, 10);
        }
      }
      if (state.isCut) {
        state.copyData = null;
      }
    },

    cut(state, isBatch) {
      if (!isBatch && (!state.curComponent || state.curComponent.id === "Back")) {
        toast("请选择组件");
        return;
      }

      restorePreCutData(state);
      copyData(state, isBatch);
      if (isBatch) {
        store.commit("batchDeleteComponent", state.areaData.components);
        eventBus.$emit("hideArea");
      } else {
        store.commit("deleteComponent");
      }
      state.isCut = true;
    },
  },
};

function restorePreCutData(state) {
  if (state.isCut && state.copyData) {
    const index = state.copyData.index;
    if (Array.isArray(state.copyData.data)) {
      const components = state.copyData.data.map((item) => deepCopy(item));
      store.commit("batchAddComponents", { components, index });
    } else {
      const data = deepCopy(state.copyData.data);
      store.commit("addComponent", { component: data, index });
    }
    if (state.curComponentIndex >= index) {
      state.curComponentIndex++;
    }
  }
}

function copyData(state, isBatch) {
  let data = null;
  let index = null;
  let areaStyle = null;
  if (isBatch) {
    const { components = [], style } = state.areaData;
    data = components.map((item) => deepCopy(item));
    areaStyle = { ...style };
  } else {
    data = deepCopy(state.curComponent);
    index = state.curComponentIndex;
  }
  state.copyData = {
    data,
    index,
    areaStyle,
  };
}
